import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareCursor: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-cursor, cursor box, arrow"><path d="M20.25 10.75V3.75H3.75V20.25H10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M11.75 11.75L14.5 21.25L17 17L21.25 14.5L11.75 11.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareCursor;
